import React from "react";
import PropTypes from "prop-types";

const DrugTestingPolicyPage = ({signatureData, staffSignatureData, currentDate}) => {
  return (
    <div
      style={{
        fontFamily: "Arial",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.2",
        fontSize: "12pt",
        height: "2440px",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <h2
          style={{
            display: "inline-block",
            fontSize: "16pt",
            fontFamily: "Arial",
            marginBottom: "15px",
            borderBottom: "2px solid black",
            paddingBottom: "0px",
            fontWeight: "bold",
          }}
        >
          DRUG TESTING POLICY, PROCEDURE AND CONFIRMATION POLICY
        </h2>
      </div>

      {/* POLICY Section */}
      <section style={{ marginBottom: "20px", margin: "10px" }}>
        <div style={{ margin: "20px 10px" }}>POLICY:</div>
        <p style={{ marginLeft: "10px", textAlign: "justify" }}>
          It is the policy of Legacy Healing Center Margate to conduct a urine
          and breathalyzer test on each client. The results of any and all lab
          work will be reviewed, signed, and dated during the assessment
          process. A drug screen is to be conducted at the time of admission and
          thereafter if deemed necessary by staff. The proper consent form must
          be in the client/resident record. Drug testing on clients is for the
          sole purpose of monitoring substance use as prescribed by the relapse
          prevention plan.
        </p>
      </section>

      {/* PROCEDURE Section */}
      <section style={{ marginBottom: "20px", margin: "10px" }}>
        <div style={{ margin: "20px 10px" }}>PROCEDURE:</div>

        <ol style={{ paddingLeft: "30px" }}>
          <li style={{ marginBottom: "10px" }}>
            Inclusive in the orientation process, clients are to sign consent
            for drug screening.
          </li>
          <li style={{ marginBottom: "10px" }}>
            Screens will be completed upon admission, randomly at least once a
            week and with cause for suspicion.
          </li>
          <li style={{ marginBottom: "10px" }}>
            Urine Drug Tests (UDT):
            <ol type="a" style={{ paddingLeft: "30px" }}>
              <li>Staff are to wear gloves at all times</li>
              <li>
                Collection cups are to be stored in a temperature-controlled
                office. Cups with temperature gauge are to be utilized.
              </li>
              <li>
                Provide individuals with collection cup. Urine collection is
                observed. Staff is to accompany individuals to the bathroom and
                stand inside the bathroom during the collection period.
              </li>
              <li>
                Upon collection, accompany individual to a private area for
                testing.
              </li>
              <li>Testing of urine is to occur in front of the individual</li>
              <li>
                Screen:
                <ol type="i" style={{ paddingLeft: "30px" }}>
                  <li>Admission and suspicion: 12 panel screen</li>
                </ol>
              </li>
              <li>
                Remove testing device from pouch and remove plastic top from
                collection cup.
              </li>
              <li>
                Dip testing device into the urine and hold in place for a
                minimum of 19 seconds
              </li>
              <li>Remove testing device from urine and replace the cap.</li>
              <li>
                Place testing device on a flat surface and wait 3 to 5 minutes
              </li>
              <li>
                Read test.
                <ol type="i" style={{ paddingLeft: "30px" }}>
                  <li>
                    Negative: two double lines: Test is negative if there are
                    two double lines. Second line may be light in color.
                  </li>
                  <li>Positive: One line on cup test is positive.</li>
                  <li>
                    Invalid: One line on the bottom or no line indicates the
                    test is invalid.
                  </li>
                </ol>
              </li>
              <li>
                Actions to be taken:
                <ol type="i" style={{ paddingLeft: "30px" }}>
                  <li>
                    Negative: Dispose of urine down the toilet and document
                    immediately in clients record.
                  </li>
                  <li>
                    Positive:
                    <ol type="1" style={{ paddingLeft: "30px" }}>
                      <li>
                        Admits to use: Contact supervisor and document in the
                        client records.
                      </li>
                      <li>
                        Denies Use: New Admission: Positive reading could be
                        from use of detoxification medication. Results to be
                        documented in client record, supervisor to be notified.
                        Test to be repeated every two days.
                      </li>
                    </ol>
                  </li>
                  <li>
                    Denies Use: Suspicion or random: Follow procedure for
                    sending urine sample to independent lab. Results to be
                    documented in client record. (See policy for UDS
                    Confirmation)
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li style={{ marginBottom: "10px" }}>
            Breathalyzer: Upon admission, suspicion or randomly, clients are to
            undergo a breathalyzer test for the presence of alcohol.
            <ol type="a" style={{ paddingLeft: "20px" }}>
              <li>
                Each client is provided a breathalyzer tip upon admission. Tip
                is to be stored in a temperature controlled office.
              </li>
              <li>Clients are to blow into the breathalyzer tip.</li>
              <li>
                Staff to press button 'in' on the front of the breathalyzer.
                Machine will start to count down from 200 to zero and will
                'beep'
              </li>
              <li>
                When the machine 'beeps' instruct the client to continue to blow
                into the tip until the machine beeps again. Read the
                breathalyzer when the machine beeps for the third time and the
                green light goes on.
              </li>
              <li>
                Positive reading: Notify supervisor, document the result
                immediately in the clients file.
              </li>
              <li>
                Negative reading document the result immediately in the clients
                file.
              </li>
            </ol>
          </li>
        </ol>
      </section>

      {/* CONFIRMATION POLICY Section */}
      <section style={{ marginBottom: "20px", margin: "10px",marginTop:"40px" }}>
        <div style={{ margin: "40px 10px" }}>CONFIRMATION POLICY:</div>

        <ul
          style={{
            listStyleType: "disc",
            paddingLeft: "20px",
          }}
        >
          <li style={{ marginBottom: "10px" }}>
            Any positive POC urine drug screens will be sent to the lab for
            confirmation testing at the clients expense($25). If the screening
            confirmation is complete and comes back to be negative, Legacy
            Healing Center Margate will credit the clients account the cost for
            testing. If the test comes back positive the client will be moved up
            in their level of care, transferred or discharged.
          </li>
          <li style={{ marginBottom: "10px" }}>
            Failure to comply with drug testing requirements will result in
            immediate discharge/transfer out of the residence.
          </li>
          <li style={{ marginBottom: "10px" }}>
            While the confirmation test is being completed the resident may be
            asked to move to a separate unit or move up in level of care until
            results have been confirmed.
          </li>
        </ul>
      </section>

      {/* Signature Section */}
      <div style={{ marginTop: "80px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div style={{ marginBottom: "30px" }}>
            <img
              src={signatureData || ""}
              alt="Client Signature"
              style={{
                width: "200px",
                height: "70px",
                borderBottom: "1px solid black",
              }}
            />
            <p>
              <span>Resident Signature:</span>
            </p>
          </div>
          <div style={{ marginBottom: "20px" }}>
          {!currentDate && (
            <div
              style={{
                borderBottom: "1px solid black",
                width: "100px",
                height: "30px",
              }}
            ></div>
          )}
          <p>Date: {currentDate}</p>
        </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "70px",
          }}
        >
          <div style={{ marginBottom: "30px" }}>
            <img
              src={staffSignatureData || ""}
              alt="Client Signature"
              style={{
                width: "200px",
                height: "70px",
                borderBottom: "1px solid black",
              }}
            />
            <p>
              <span>staff Signature:</span>
            </p>
          </div>
          <div style={{ marginBottom: "20px" }}>
          {!currentDate && (
            <div
              style={{
                borderBottom: "1px solid black",
                width: "100px",
                height: "30px",
              }}
            ></div>
          )}
          <p>Date: {currentDate}</p>
        </div>
        </div>
      </div>
    </div>
  );
};

DrugTestingPolicyPage.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
};

export default DrugTestingPolicyPage;
